import React from 'react';
import PT from 'prop-types';
import logo from './assets/dollar.svg';

const AmountPaid = ({ title, amount }) => {

	return (
		<div className="available-days-counter"
			data-testid="available-days-counter">
			<div className="available-days-counter__title">
				<img src={logo} alt="logo" />
			</div>
			<div className="available-days-counter__item" >
				<div className="available-days-counter__item-content">
					<span className="available-days-counter__allocation-type">
						{title}
					</span>
					<span className="available-days-counter__days-amount">
						{amount} USD
					</span>
				</div>
			</div>

		</div>
	);
};

AmountPaid.propTypes = {
	title: PT.string,
	amount: PT.string
};

export default AmountPaid;
